module.exports = __webpack_public_path__ + "static/media/WhipAround_ios_1.be487a7f.jpg";